<template>
  <div class="p-5 h-screen overflow-y-auto">
    <AlarmFixPopup v-if="isPopupVisible">
      <div>
        <p>你選擇第 {{ singleAlarmInfo.alarm_num }} 個警告</p>
        <p>警告為 {{ singleAlarmInfo.message }}</p>
      </div>
    </AlarmFixPopup>

    <div class="px-3 py-5 mb-5 rounded-3xl" style="background-image: linear-gradient(to right, #4facfe 0%, #00f2fe 100%)">
      <div class="flex flex-row justify-between mb-5 gap-4">
        <a-date-picker
          class="flex-grow flex-shrink-0"
          :size="size"
          :default-value="moment(startDate, 'YYYY-MM-DD hh:mm:ss')"
          show-time
          placeholder="起始時間"
          @change="StartDateChange"
        />
        <div class="flex items-center">-</div>
        <a-date-picker
          class="flex-grow flex-shrink-0"
          :size="size"
          :default-value="moment(endDate, 'YYYY-MM-DD hh:mm:ss')"
          showToday
          show-time
          placeholder="結尾時間"
          @change="EndDateChange"
        />
      </div>

      <div class="flex gap-8">
        <!-- <TextInput ref="deviceSearchWord" class="flex-grow" placeholder="裝置名稱"></TextInput> -->
        <DeviceSearchSelect
          :size="size"
          class="flex-grow"
          placeholder="請選擇機台"
          :include-all-option="true"
          @change="SearchDevice"
        />
        <a-button @click="SearchAPI()" type="primary" icon="search"> Search </a-button>
      </div>
    </div>

    <a-table :data-source="alarmList" :columns="columns" :pagination="false" :rowKey="(record) => record.alarm_num">
      <template slot="customRender" slot-scope="text, record, index, column">
        <span v-if="column.dataIndex === 'issuetime'">{{ new Date(record.issuetime).toLocaleString() }}</span>
        <span v-if="column.dataIndex === 'lifttime'">
          {{ record.lifttime ? new Date(record.lifttime).toLocaleString() : "--" }}
        </span>
        <span v-if="column.dataIndex === 'solution'">
          <span v-if="record.solution">{{ record.solution }}</span>
          <span @click="ShowFixPopup(record)" v-else>未解決</span>
        </span>
      </template>
    </a-table>
    <a-pagination :total="total" :current="current" :page-size="pageSize" @change="PageChange"></a-pagination>
  </div>
</template>

<script>
import AlarmFixPopup from '@/components/AlarmFixPopup.vue'
import DeviceSearchSelect from '@/components/DeviceSearchSelect.vue'
import moment from 'moment'
// import DatePicker from '../components/DatePicker.vue'
// import TextInput from '../components/TextInput.vue'
// import TimeClock from '../components/TimeClock.vue'
export default {
  name: 'AlarmList',
  components: {
    AlarmFixPopup,
    DeviceSearchSelect
    // DatePicker,
    // TextInput
    // TimeClock
  },
  data () {
    return {
      baseURL: this.GLOBAL.baseURL,
      basePort: this.GLOBAL.basePort,
      isPopupVisible: false,
      size: 'large',
      deviceSearchWord: '',
      alarmList: [],
      singleAlarmInfo: {},
      columns: [
        {
          title: '機台名稱',
          dataIndex: 'device_name',
          key: 'device_name'
        },
        {
          title: '裝置名稱',
          dataIndex: 'name',
          key: 'name'
        },
        {
          title: '編號',
          dataIndex: 'alarm_num',
          key: 'alarm_num',
          width: 80
        },
        {
          title: '發生時間',
          dataIndex: 'issuetime',
          key: 'issuetime',
          scopedSlots: {
            customRender: 'customRender'
          }
        },
        {
          title: '警告訊息',
          dataIndex: 'message',
          key: 'message',
          ellipsis: true
        },
        {
          title: '解決時間',
          dataIndex: 'lifttime',
          key: 'lifttime',
          scopedSlots: {
            customRender: 'customRender'
          }
        },
        // {
        //   title: 'code',
        //   dataIndex: 'code',
        //   key: 'code'
        // },
        {
          title: 'model',
          dataIndex: 'model',
          key: 'model'
        },
        // {
        //   title: 'serial',
        //   dataIndex: 'serial',
        //   key: 'serial'
        // },
        // {
        //   title: 'subcode',
        //   dataIndex: 'subcode',
        //   key: 'subcode'
        // },
        {
          title: '解決方法',
          dataIndex: 'solution',
          key: 'solution',
          scopedSlots: {
            customRender: 'customRender'
          }
        }
      ],
      current: 1,
      pageSize: 8,
      total: 0,
      startDate: null,
      endDate: null,
      fixStates: 2,
      deviceMac: null,
      today: '2024-08-11'
    }
  },
  computed: {
    getCurrentPageData () {
      const startIndex = (this.current - 1) * this.pageSize
      const endIndex = startIndex + this.pageSize
      return this.alarmList.slice(startIndex, endIndex)
    },
    mqttClient: {
      get () {
        return this.$store.state.mqttClient
      },
      set () {}
    }
  },
  created () {
    // this.GetAlarmTotalCount()
    this.GetCurrentDate()
  },
  mounted () {
    this.SearchAPI()
    // this.GetAlarmList()
  },

  methods: {
    moment,
    GetCurrentDate () {
      const today = new Date()
      const year = today.getFullYear()
      const month = (today.getMonth() + 1).toString().padStart(2, '0')
      const day = today.getDate().toString().padStart(2, '0')
      this.startDate = `${year}-${month}-${day}` + ' ' + '00:00:00'
      this.endDate = `${year}-${month}-${day}` + ' ' + '23:59:59'
    },
    SearchDevice (value) {
      this.deviceMac = value
    },
    EndDateChange (value, dateString) {
      // console.log('Selected Time: ', value)
      // console.log('Formatted Selected Time: ', dateString)
      this.endDate = dateString
    },
    StartDateChange (value, dateString) {
      // console.log('Selected Time: ', value)
      // console.log('Formatted Selected Time: ', dateString)
      this.startDate = dateString
    },
    SearchAPI () {
      this.axios
        .post(this.baseURL + this.basePort + '/alarm/alarmSearch', {
          deviceMac: this.deviceMac,
          startDate: this.startDate,
          endDate: this.endDate,
          fixStates: this.fixStates,
          pageNumber: this.current,
          pageSize: this.pageSize
        })
        .then((res) => {
          console.log(res.data)
          if (res.data.message === 'success') {
            this.alarmList = res.data.data
            this.total = res.data.totalCount
          } else {
          }
        })
        .catch((error) => {
          // 處理上傳失敗的回應
          console.error(error)
        })
    },
    PageChange (page) {
      this.current = page
      // console.log('現在頁碼:', this.current)
      this.SearchAPI()
    },
    ShowFixPopup (record) {
      this.isPopupVisible = true
      this.singleAlarmInfo = record
    },
    GetAlarmList () {
      this.axios
        .post(this.baseURL + this.basePort + '/alarm/alarmList', {
          pageNumber: this.current,
          pageSize: this.pageSize
        })
        .then((res) => {
          console.log(res.data)
          if (res.data.message === 'success') {
            // console.log(res.data.data)
            // this.$store.commit('alarmList', res.data.data)
            // this.alarmList = this.alarmList.concat(res.data.data)
            this.alarmList = res.data.data
            // this.pagination.total = res.data.totalCount
          } else {
          }
        })
        .catch((error) => {
          // 處理上傳失敗的回應
          console.error(error)
        })
    },
    GetAlarmTotalCount () {
      this.axios
        .post(this.baseURL + this.basePort + '/alarm/alarmTotalCount', {})
        .then((res) => {
          console.log(res.data)
          if (res.data.message === 'success') {
            this.total = res.data.data
          } else {
          }
        })
        .catch((error) => {
          console.error(error)
        })
    }
  }
}
</script>

<style lang="css" scoped>
.ant-btn {
  font-size: 20px;
  /* padding: -10px 15px -25px 15px; */
  height: 38px;
  padding-bottom: 5px;
}
</style>
